module.exports = __webpack_public_path__ + "static/img/10.585278e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/1/zh/10.png
// module id = li6e
// module chunks = 0